const rawFlag =
  process.env.NEXT_PUBLIC_FREE_MODE ??
  process.env.FREE_MODE ??
  "true"

export const isFreeMode = rawFlag.toLowerCase() === "true"

